module.exports = __webpack_public_path__ + "img/horizontal_3_7_6000.45cbedd9.png";